import { PostscriptSettingsForm } from './postscript-settings';
import { TransactionsFilteringForm } from '@/routes/trackings/components/transactions-filtering-form';
import { useNavigate, useParams } from 'react-router-dom';
import {
  createSetupNavigator,
  DestinationTrackingDetails
} from '../../components/destination-tracking-details';
import { useCallback, useMemo, useState } from 'react';

export const PostscriptTrackingDetails = ({ isSetup }: { isSetup: boolean }) => {
  const navigate = useNavigate();
  const { tab: tabFromParams = 'postscript-settings', id } = useParams<{
    tab: string;
    id: string;
  }>();

  const [displayTabs, setDisplayTabs] = useState([
    {
      label: 'Postscript Settings',
      value: 'postscript-settings',
      disabled: false,
      setupCompleted: false
    },
    {
      label: 'Transactions',
      value: 'transactions',
      disabled: true,
      setupCompleted: false
    }
  ]);

  const [activeTab, setActiveTab] = useState(tabFromParams || displayTabs[0].value);

  const handleTabChange = useCallback(
    (newTabValue: string) => {
      setActiveTab(newTabValue);
      void navigate(`../integrations/${id!}/${newTabValue}`, { replace: true, state: { isSetup } });
    },
    [navigate, id, isSetup, setActiveTab]
  );

  const navigateToNextStep = useMemo(
    () =>
      createSetupNavigator(
        () => displayTabs,
        () => activeTab,
        setDisplayTabs,
        handleTabChange
      ),
    [displayTabs, activeTab, handleTabChange]
  );

  const handleNonSetupContinue = useCallback(() => {
    // TODO: FIX LOGIC SO EMPTY FUNCTION IS NOT NEEDED
  }, []);
  const onContinue = isSetup ? navigateToNextStep : handleNonSetupContinue;

  const content = [
    {
      key: 'postscript-settings',
      content: <PostscriptSettingsForm onContinue={onContinue} />
    },
    {
      key: 'transactions',
      content: (
        <TransactionsFilteringForm isSetup={isSetup} isLastTab={true} onContinue={onContinue} />
      )
    }
  ];

  return (
    <DestinationTrackingDetails
      displayTabs={displayTabs}
      isSetup={isSetup}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      id={id!}
      content={content}
    />
  );
};
